<style lang="scss">
.call-overview {}
</style>

<!-- eslint-disable -->
<template>
  <b-card class="call-overview">
    <b-card-title>
      <section class="d-flex justify-content-between align-items-center">
        Call Overview
        <b-badge v-if="call.booked_by"
                 variant="primary">{{call.booked_by === 'Visitor' ? 'Visitor' : $options.filters.term(call.booked_by.toLowerCase(), true)}} requested</b-badge>
      </section>
    </b-card-title>
    <b-alert variant="warning" class="p-1" v-if="call.offsite_id && call.cs_version !== -1" show>Please note this is an inter-prison call</b-alert>
    <b-alert variant="warning" class="p-1" v-if="call.offsite_id && call.cs_version === -1" show>Please note this is a PV on Demand call</b-alert>
    <b-alert v-if="visitorsFirstCall && showFirstCallAlert" class="p-1" show variant="danger">This is the visitor's first video call</b-alert>
    <slot></slot>
    <p class="detail-item mb-0">
      <b cy="o-name">{{call.visitor.firstname}} {{call.visitor.lastname}}</b> has requested a video call with resident
      <b cy="o-prisoner">{{call.prisoner.firstname}} {{call.prisoner.lastname}}</b>, {{'prison' | term(true)}} number: <b>{{call.prisoner.prisoner_number}}</b>,
      <b cy="o-wing">{{getWingInfo()}}</b>
      on the <b cy="o-date">{{getRequestedOrBookedDate()}}</b>
    </p>

    <div v-if="showCancelButton" class="mt-2 d-flex justify-content-end">
      <b-btn @click="showModal('modal-cancel')"
             variant="warning" v-if="!call.call_security_running">Cancel Video Call</b-btn>
    </div>

    <b-modal id="modal-cancel" hide-footer>
      <cancel-call @close="closeAndRefresh()" :call="call"></cancel-call>
    </b-modal>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
import {mapState} from 'vuex';
import CancelCall from '@/components/calls/CancelCall.vue';
import {getVisitBookedForDate, getVisitRequestedDates} from '@/util/helpers';

export default {
  components: {
    CancelCall,
  },
  props: {
    showCancelButton: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      test: '',
    };
  },
  computed: {
    ...mapState({
      prison: state => state.prison.prison,
      call: state => state.callDetails.call,
      visitorsFirstCall: state => state.callDetails.visitorsFirstCall,
    }),
    showFirstCallAlert() {
      const allowedStatuses = ['Funded', 'Approved', 'AwaitingPayment'];
      return allowedStatuses.includes(this.call.status);
    },
  },
  mounted() {
  },
  methods: {
    showModal(name) {
      this.$bvModal.show(name);
    },
    async closeAndRefresh() {
      await this.$store.dispatch('callDetails/getCall', this.$route.params.id);
      this.$bvModal.hide('modal-cancel');
    },
    getWingInfo() {
      if(this.call) {
        if(this.call.booked_slot) {
          if(this.call.booked_slot.wing_id && this.call.booked_slot.wing_name) {
            return `${this.call.booked_slot.wing_name},`;
          }
          return '';
        } else if(this.call.requested_booking_slot_1 && this.call.requested_booking_slot_1.wing_id && this.call.requested_booking_slot_1.wing_name) {
          return `${this.call.requested_booking_slot_1.wing_name},`;
        } else {
          return '';
        }
      }
      return '';
    },
    getRequestedOrBookedDate() {
      if(this.call) {
        if(this.call.booked_slot) {
          const bookedFor = getVisitBookedForDate(this.call);
          return bookedFor.bookedFor;
        } else {
          const requestedFor = getVisitRequestedDates(this.call);
          if(this.call.requested_booking_slot_2) {
            return requestedFor.requestedFor1 + ' or ' + requestedFor.requestedFor2;
          }
          return requestedFor.requestedFor1;
        }
      }
      return '-';
    },
  },
};
</script>
